import { createEntityAdapter } from '@reduxjs/toolkit';

import type { SubcatalogAPIData } from 'types/catalog_types';

const subcatalogsAdapter = createEntityAdapter<SubcatalogAPIData>();

export default subcatalogsAdapter;
